import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _351f4b15 = () => interopDefault(import('../pages/bon-plans/index.vue' /* webpackChunkName: "pages/bon-plans/index" */))
const _0efa843f = () => interopDefault(import('../pages/clients/index.vue' /* webpackChunkName: "pages/clients/index" */))
const _1cc1e330 = () => interopDefault(import('../pages/commandes/index.vue' /* webpackChunkName: "pages/commandes/index" */))
const _5f17a97e = () => interopDefault(import('../pages/config/index.vue' /* webpackChunkName: "pages/config/index" */))
const _5ed9e904 = () => interopDefault(import('../pages/coupons/index.vue' /* webpackChunkName: "pages/coupons/index" */))
const _f8134e00 = () => interopDefault(import('../pages/enviemoment/index.vue' /* webpackChunkName: "pages/enviemoment/index" */))
const _4ba98bfc = () => interopDefault(import('../pages/historique/index.vue' /* webpackChunkName: "pages/historique/index" */))
const _c55e88cc = () => interopDefault(import('../pages/instituts/index.vue' /* webpackChunkName: "pages/instituts/index" */))
const _07a7f4fe = () => interopDefault(import('../pages/livraisons/index.vue' /* webpackChunkName: "pages/livraisons/index" */))
const _55a15467 = () => interopDefault(import('../pages/marques/index.vue' /* webpackChunkName: "pages/marques/index" */))
const _22cfc366 = () => interopDefault(import('../pages/messagerie/index.vue' /* webpackChunkName: "pages/messagerie/index" */))
const _5d6a507f = () => interopDefault(import('../pages/panneau/index.vue' /* webpackChunkName: "pages/panneau/index" */))
const _2d30aaee = () => interopDefault(import('../pages/planification.vue' /* webpackChunkName: "pages/planification" */))
const _c20ba0bc = () => interopDefault(import('../pages/points/index.vue' /* webpackChunkName: "pages/points/index" */))
const _3271b591 = () => interopDefault(import('../pages/praticienne/index.vue' /* webpackChunkName: "pages/praticienne/index" */))
const _60c8a5ce = () => interopDefault(import('../pages/prestations/index.vue' /* webpackChunkName: "pages/prestations/index" */))
const _09896de3 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _5d142c1c = () => interopDefault(import('../pages/products-drafts/index.vue' /* webpackChunkName: "pages/products-drafts/index" */))
const _bec8d62e = () => interopDefault(import('../pages/produits/index.vue' /* webpackChunkName: "pages/produits/index" */))
const _798a6e02 = () => interopDefault(import('../pages/retours/index.vue' /* webpackChunkName: "pages/retours/index" */))
const _80bb0656 = () => interopDefault(import('../pages/salons/index.vue' /* webpackChunkName: "pages/salons/index" */))
const _cd9db982 = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _697c7b1e = () => interopDefault(import('../pages/auth/connexion.vue' /* webpackChunkName: "pages/auth/connexion" */))
const _879181c4 = () => interopDefault(import('../pages/auth/forgot.vue' /* webpackChunkName: "pages/auth/forgot" */))
const _8df195b8 = () => interopDefault(import('../pages/auth/reset.vue' /* webpackChunkName: "pages/auth/reset" */))
const _482400f4 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  scrollBehavior,

  routes: [{
    path: "/bon-plans",
    component: _351f4b15,
    name: "bon-plans"
  }, {
    path: "/clients",
    component: _0efa843f,
    name: "clients"
  }, {
    path: "/commandes",
    component: _1cc1e330,
    name: "commandes"
  }, {
    path: "/config",
    component: _5f17a97e,
    name: "config"
  }, {
    path: "/coupons",
    component: _5ed9e904,
    name: "coupons"
  }, {
    path: "/enviemoment",
    component: _f8134e00,
    name: "enviemoment"
  }, {
    path: "/historique",
    component: _4ba98bfc,
    name: "historique"
  }, {
    path: "/instituts",
    component: _c55e88cc,
    name: "instituts"
  }, {
    path: "/livraisons",
    component: _07a7f4fe,
    name: "livraisons"
  }, {
    path: "/marques",
    component: _55a15467,
    name: "marques"
  }, {
    path: "/messagerie",
    component: _22cfc366,
    name: "messagerie"
  }, {
    path: "/panneau",
    component: _5d6a507f,
    name: "panneau"
  }, {
    path: "/planification",
    component: _2d30aaee,
    name: "planification"
  }, {
    path: "/points",
    component: _c20ba0bc,
    name: "points"
  }, {
    path: "/praticienne",
    component: _3271b591,
    name: "praticienne"
  }, {
    path: "/prestations",
    component: _60c8a5ce,
    name: "prestations"
  }, {
    path: "/products",
    component: _09896de3,
    name: "products"
  }, {
    path: "/products-drafts",
    component: _5d142c1c,
    name: "products-drafts"
  }, {
    path: "/produits",
    component: _bec8d62e,
    name: "produits"
  }, {
    path: "/retours",
    component: _798a6e02,
    name: "retours"
  }, {
    path: "/salons",
    component: _80bb0656,
    name: "salons"
  }, {
    path: "/users",
    component: _cd9db982,
    name: "users"
  }, {
    path: "/auth/connexion",
    component: _697c7b1e,
    name: "auth-connexion"
  }, {
    path: "/auth/forgot",
    component: _879181c4,
    name: "auth-forgot"
  }, {
    path: "/auth/reset",
    component: _8df195b8,
    name: "auth-reset"
  }, {
    path: "/",
    component: _482400f4,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
